import "./index.css"
export default function PageSix() {
    return (
        <div class="text-light">
            <h1 className="text-center">Lepton Artist Funding Scheme</h1>
            <div className="page6-background">
                <p>LeptonMusic is committed to supporting the musical career of the new generation of musicians 52% of
                musicians in China have no music income, 24% of musicians' music income accounts for less than 5% of
                their total income, and most musicians' income is difficult to support theirmusical dreams.
                In view of this, LeptonMusic provides a fully transparent, non-exploitative, democratic, and
                middleman-free music ecosystem for the new generation of musicians, where all royalties go to content
                artists. Lepton artist Funding Program#Based on the philosophy of supporting early-career musicians,
                    Lepton launches</p>
                <p>(1) Lepton Artist Funding Program: LeptonMusic withdraws LeptonMusic Coin equivalent to 50,000 US dollars
                every year, and provides funding to 100 new generationmusicians</p>
                <p>(2) Lepton Popularity Program: The platform give additional exposure to selected musiccontents ranging
                from 1,000-10,000</p>
                <p>(3) Crypto Music Beginners Support Program: Inject 1-100 additional music coins into the corresponding
                artist’s music mining pool</p>

            </div>

        </div>

    )
}